module.exports = __webpack_public_path__ + "static/media/icon_time-bofa.da5baabb.svg";